import { ThunkResult } from '../../store'
import workOrderApi from '../../apis/workOrder.api'
import workOrderService from '../../services/workOrder.service'
import { replaceResult, replaceResultData } from './WorkOrders.slice'

export function paginate (): ThunkResult<void> {
  return (dispatch, getState) => {
    const { page, limit, search } = getState().workOrders
    const params = { page, limit, search }
    workOrderApi.paginate(params, paginate => {
      if (!paginate) return
      dispatch(replaceResult(paginate))
    })
  }
}

export function deleteWorkOrder (id: number): ThunkResult<void> {
  return (dispatch, getState) => {
    workOrderApi.delete(id, workOrder => {
      if (!workOrder) return
      const { result } = getState().workOrders
      const data = workOrderService.delete(result.data, id)
      dispatch(replaceResultData(data))
    })
  }
}
